import { IProductFile } from '../dataModels/ProductModels';
import * as style from './style.css';

import CloudIcon from '../../../assets/icons/Cloud';
import * as prodStyle from '../style.css';
import React = require('react');

interface IProps {
    files: IProductFile[];
}
interface IState {
}

export default class ModelFiles extends React.Component<IProps, IState> {
    render() {
        return (
            <div className={style.filesWrapper}>
                <div className={style.files}>
                    {this.props.files.map((f, i) => this.file(f, i))}
                </div>
            </div>
        );
    }

    file(f: IProductFile, i: number): any {
        return <div key={i} className={prodStyle.dataRow}>
            <div className={style.fileName} >
                <a href={f.download}>
                    <CloudIcon />
                </a>
                {f.name}
            </div>

        </div>;
    }
}
